import React from 'react';
import ReactCSSTransitionGroup from 'react-addons-css-transition-group';
import Question from 'react/app/components/Question';
import QuestionCount from 'react/app/components/QuestionCount';
import AnswerOption from 'react/app/components/AnswerOption';

function Quiz(props) {


    function renderAnswerOptions(key) {
        return (
            <AnswerOption
            key={key.id}
            answerContent={key.option}
            answerType={key.id}
            answer={props.answer}
            questionId={props.questionId}
            onAnswerSelected={props.onAnswerSelected}
            />
            );
    }

    return (
        <div>
            <div className="col-lg-12">
                <div className="card-box widget-box-one">

                    <div className="wigdet-one-content">
                        <Question content={props.question} />
                        <div className="row">
                            <ul className="list-unstyled">
                                {props.options.map(renderAnswerOptions)}
                            </ul>

                        </div>
                    </div>
                </div>
            </div>

        <ReactCSSTransitionGroup
        className="container"
        component="div"
        transitionName="fade"
        transitionEnterTimeout={800}
        transitionLeaveTimeout={500}
        transitionAppear
        transitionAppearTimeout={500}
        >
      <div key={props.questionId}>

        <QuestionCount
        counter={props.questionId}
        total={props.questionTotal}
        />



      </div>
    </ReactCSSTransitionGroup>
        </div>
        );
}

Quiz.propTypes = {
    answer: React.PropTypes.number.isRequired,
    options: React.PropTypes.array.isRequired,
    question: React.PropTypes.string.isRequired,
    questionId: React.PropTypes.number.isRequired,
    questionTotal: React.PropTypes.number.isRequired,
    onAnswerSelected: React.PropTypes.func.isRequired
};

export default Quiz;



// WEBPACK FOOTER //
// ./react/app/Components/Quiz.js